import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { getCognitoId } from 'components/util/UserId'
import { navigate } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import React, { useEffect, useState } from 'react'
import { isAppleDevice } from 'utils/get-browser-device'
import Clock from '../../../images/Clock.svg'

import './index.css'

enum LeftSectionType {
  Image = 'image',
  Text = 'textImage',
  Asterix = 'textImageWithAsterix'
}

interface Props {
  backgroundColor: string
  cloudinaryHeaderImage: string
  builderHeaderImage: any
  cloudinaryHeaderImageAltText: string
  cloudinaryTextImage: any
  builderTextImage: any
  cloudinaryTextImageAltText: string
  buttonEnabled: boolean
  buttonProp: LinkButtonProp
  widgetBackgroundColor: string
  widgetType: WidgetType
  widgetTags: string
  ratingTextBold: string
  ratingTextNormalOne: string
  ratingTextNormalTwo: string
  ratingIcon: string
  builderRatingIcon: any
  tagline: string
  displayTagline: boolean
  heroFooterBackground: string
  leftSection: LeftSectionType
  titleOne: string
  titleOneBold: string
  contentText: string
  coupon: string
  highlightedOfferText: string
  highlightedOffer: boolean
  showBackgroundFooter: boolean
}

const HeroDogCTAAlternate = ({
  backgroundColor,
  cloudinaryHeaderImage,
  builderHeaderImage,
  cloudinaryHeaderImageAltText,
  cloudinaryTextImage,
  builderTextImage,
  cloudinaryTextImageAltText,
  buttonEnabled,
  buttonProp,
  widgetBackgroundColor,
  widgetType,
  widgetTags,
  ratingTextBold = '',
  ratingTextNormalOne = '',
  ratingTextNormalTwo = '',
  ratingIcon,
  builderRatingIcon,
  tagline,
  displayTagline,
  heroFooterBackground,
  leftSection,
  titleOne,
  titleOneBold,
  contentText,
  coupon = '',
  highlightedOfferText,
  highlightedOffer,
  showBackgroundFooter
}: Props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [deviceType, setDeviceType] = useState('')
  const dogDetailsPage = 'dog-details'

  useEffect(() => {
    const authenticateUser = async () => {
      try {
        const { username } = await getCognitoId()

        if (username) {
          setIsLoggedIn(true)
        }
      } catch (e) {
        console.log(e)
      }
    }

    authenticateUser()
  }, [isLoggedIn])

  useEffect(() => {
    setDeviceType(isAppleDevice)
  }, [])

  useEffect(() => {
    const trustWidget = document.getElementById('trust-pilot-micro-combo')
    window.Trustpilot?.loadFromElement(trustWidget)
  }, [widgetType])

  const renderMobileBanner = () => {
    if (cloudinaryHeaderImage?.public_id) {
      return (
        <CdnImage
          className="index-2 relative h-auto min-h-[11rem] w-full object-cover"
          url={builderHeaderImage}
          alt={cloudinaryHeaderImageAltText}
          lazyLoad={false}
          steps={[413, 990]}
        />

        // <>
        //   {builderHeaderImage ? (
        //     <CdnImage
        //       className="index-2 relative h-full min-h-[11rem] w-full object-cover"
        //       url={builderHeaderImage}
        //       alt={cloudinaryHeaderImageAltText}
        //       lazyLoad={false}
        //       steps={[413, 990]}
        //     />
        //   ) : (
        //     <CloudinaryImage
        //       className="index-2 relative h-full min-h-[11rem] w-full object-cover"
        //       publicId={cloudinaryHeaderImage?.public_id}
        //       alt={cloudinaryHeaderImageAltText}
        //       loading={'eager'}
        //       steps={[413, 990]}
        //     />
        //   )}
        // </>
      )
    }
  }

  const renderHeroLeftSection = () => {
    if (leftSection === 'textImage') {
      return (
        <div>
          <div className="text-center pb-2">
            <span className="text-[#006685] text-2xl font-medium font-serif">{titleOne}</span>
            <br />
            <div className="mb-0" />
            <span className="text-[#004355] text-2xl font-medium font-serif"> {titleOneBold}</span>
          </div>
          <p
            className={`enable-list-styles text-xs md:text-sm font-medium font-sans w-full text-center mt-4`}
            dangerouslySetInnerHTML={{ __html: contentText }}
          ></p>{' '}
        </div>
      )
    }
    if (leftSection === 'textImageWithAsterix') {
      return (
        <div>
          <div className="text-center pb-2">
            <span className="text-[#006685] text-3xl font-medium font-serif">{titleOne}</span>
            <br />
            <div className="mb-0 mt-2" />
            <span className="text-[#004355] text-5xl font-medium font-serif"> {titleOneBold}</span>
          </div>
          <p
            className={`enable-list-styles text-sm font-medium font-sans w-full text-center mt-4 mb-8`}
            dangerouslySetInnerHTML={{ __html: contentText }}
          ></p>{' '}
        </div>
      )
    }
    if (leftSection === 'image') {
      return (
        <div className={`max-h-[500px] ${deviceType === 'Apple' ? '' : 'min-h-[13rem]'}`}>
          <CdnImage
            className={`${deviceType === 'Apple' ? '' : 'aspect:auto'} mx-auto h-auto max-w-full`}
            url={builderTextImage}
            alt={cloudinaryTextImageAltText}
          />

          {/* <>
            {builderTextImage ? (
              <CdnImage
                className={'aspect:auto mx-auto h-full max-w-full'}
                url={builderTextImage}
                alt={cloudinaryTextImageAltText}
              />
            ) : (
              <CloudinaryImage
                className={'aspect:auto mx-auto h-full max-w-full'}
                publicId={cloudinaryTextImage?.public_id}
                alt={cloudinaryTextImageAltText}
                autoFormat={false}
              />
            )}
          </> */}
        </div>
      )
    }
  }

  const renderCTAButton = () => {
    if (!buttonEnabled) {
      return (
        <button
          className={`mx-auto flex w-10/12 items-center justify-center rounded-full border border-transparent bg-primary px-5 py-3 text-base font-medium text-[#FFFFFF] md:mt-8 md:w-96 md:text-lg`}
          onClick={() => {
            let eventName = isLoggedIn
              ? 'cta_component_dog_hero_cta_submit_logged_in'
              : 'cta_component_dog_hero_cta_submit'

            if (typeof window.gtag !== 'undefined') {
              window.gtag('event', eventName, {
                page: 'home_page'
              })
            }
            if (isLoggedIn) {
              navigate('/account/')
            } else {
              window.location.href = `/signup/${dogDetailsPage}/${coupon ? `?coupon=${coupon}` : ''}`
            }
          }}
        >
          {isLoggedIn ? `${buttonProp?.loggedInButtonText}` : `${buttonProp?.buttonText}`}
        </button>
      )
    }

    return null
  }

  const renderCTAButtonAndOfferText = () => {
    if (!buttonEnabled) {
      return (
        <div className="flex flex-col mx-auto w-full justify-center bg-[#D7EAD2] rounded-[30px] p-3 pb-6">
          {!highlightedOfferText && (
            <p className="font-sans font-semibold text-xs md:text-base text-center">
              30% off your first order + Free Treat
            </p>
          )}
          {highlightedOfferText && (
            <p className="font-sans font-semibold md:text-base text-xs text-center">{highlightedOfferText}</p>
          )}
          <button
            className={`mx-auto flex w-10/12 items-center justify-center rounded-full border border-transparent bg-primary px-5 py-3 text-base font-medium text-[#FFFFFF] mt-3 md:w-96 md:text-lg`}
            onClick={() => {
              let eventName = isLoggedIn
                ? 'cta_component_dog_hero_cta_submit_logged_in'
                : 'cta_component_dog_hero_cta_submit'

              if (typeof window.gtag !== 'undefined') {
                window.gtag('event', eventName, {
                  page: 'home_page'
                })
              }
              if (isLoggedIn) {
                navigate('/account/')
              } else {
                window.location.href = `/signup/${dogDetailsPage}/${coupon ? `?coupon=${coupon}` : ''}`
              }
            }}
          >
            {isLoggedIn ? `${buttonProp?.loggedInButtonText}` : `${buttonProp?.buttonText}`}
          </button>
        </div>
      )
    }

    return null
  }

  const getWidget = () => {
    return (
      <div>
        {/* <!-- TrustBox widget - Micro Combo --> */}
        <div
          className="trustpilot-widget px-8 py-4"
          data-locale="en-GB"
          data-template-id="5419b6ffb0d04a076446a9af"
          data-businessunit-id="5af423d4a3303b0001bf47c1"
          data-style-height="20px"
          data-style-width="100%"
          data-theme="light"
          data-stars="5"
          data-font-family="Montserrat"
          style={{ backgroundColor }}
          data-text-color="#004355"
          data-tags={widgetTags ? widgetTags : ''}
          id="trust-pilot-micro-combo"
        >
          <a href="https://uk.trustpilot.com/review/differentdog.com" target="_blank" rel="noreferrer noopener">
            <StaticImage objectFit="contain" className="w-full" src="../../../images/trustpilot.png" alt="Trustpilot" />
          </a>
        </div>
        {/* <!-- End TrustBox widget --> */}
      </div>
    )
  }

  const _renderRatingIcon = () => {
    return (
      <CdnImage
        className="index-2 relative inline-block h-3 w-3"
        url={builderRatingIcon}
        alt={'Dog bowl'}
        lazyLoad={false}
      />

      // <>
      //   {builderRatingIcon ? (
      //     <CdnImage
      //       className="index-2 relative inline-block h-3 w-3"
      //       url={builderRatingIcon}
      //       alt={'Dog bowl'}
      //       lazyLoad={false}
      //     />
      //   ) : (
      //     <CloudinaryImage
      //       className="index-2 relative inline-block h-3 w-3"
      //       publicId={ratingIcon?.public_id}
      //       alt={'Dog bowl'}
      //       loading={'eager'}
      //     />
      //   )}
      // </>
    )
  }

  return (
    <div
      className="bg-image-none relative -mb-4 h-full w-full md:bg-cover md:bg-bottom md:bg-no-repeat"
      style={{ backgroundColor }}
    >
      <main className="mx-auto flex h-full w-full flex-col">
        <div className="-mt-6 block h-full min-h-[11rem]">{renderMobileBanner()}</div>
        <div className="mx-auto h-auto w-2/3 justify-center pt-8">{renderHeroLeftSection()}</div>
        {!highlightedOffer && <div className="my-2 mx-auto w-3/5">{renderCTAButton()}</div>}
        {highlightedOffer && <div className="my-2 mx-auto w-4/5">{renderCTAButtonAndOfferText()}</div>}
        <div className="mt-1 text-center text-xs">
          <div className="flex flex-row justify-center">
            <img className="mr-1" width={14} src={Clock} alt="Clock" />
            <span>
              It takes about <span className="font-bold">2 mins</span>
            </span>
          </div>
        </div>
        <div className="w-full" style={{ backgroundColor: widgetBackgroundColor }}>
          {getWidget()}
          {/* <div className="bg-[#F8F2EC] text-center text-xs">
            <span className="font-bold">{ratingTextBold} </span>
            <span>
              {ratingTextNormalOne} {renderRatingIcon()} {ratingTextNormalTwo}
            </span>
          </div> */}
          {displayTagline && (
            <div style={{ backgroundColor: backgroundColor }}>
              <p
                className={'enable-list-styles text-sm flex justify-center items-center w-4/5 mx-auto text-center'}
                dangerouslySetInnerHTML={{ __html: tagline }}
              ></p>
            </div>
          )}
        </div>
      </main>
      <div
        className={`${showBackgroundFooter ? '' : 'pt-8 bg-top '} font-sans-serif relative block h-12 w-full bg-contain bg-bottom bg-no-repeat`}
        style={{ backgroundColor, backgroundImage: heroFooterBackground ? `url(${heroFooterBackground})` : 'none' }}
      ></div>
      {showBackgroundFooter && <div className={'bg-[#FAECE8] pt-8'}></div>}
    </div>
  )
}

export default HeroDogCTAAlternate
